import e, { useState as F, useMemo as x, useEffect as S } from "react";
import o from "./index222.mjs";
import { Header as H } from "./index89.mjs";
import { RadioField as V, TextField as I, EmailField as j } from "@amenitiz/design-system";
import { FIRST_NAME_FIELD as f, LAST_NAME_FIELD as g, EMAIL_FIELD as _, PHONE_NUMBER_FIELD as D } from "./index56.mjs";
import { formatPrice as z } from "./index110.mjs";
import { FieldState as r } from "./index196.mjs";
import { isEmailValid as L } from "./index201.mjs";
import { useSetAtom as m } from "jotai";
import { setSummaryButtonAtom as J, addGiftCardToCartAtom as K, addRecipientDetailsToGiftCardAtom as Q, removeGiftCardFromCartAtom as W, clearCartItemsAtom as X, clearGiftCardsAtom as Y } from "./index34.mjs";
import { generateFieldId as s } from "./index181.mjs";
const se = ({
  id: l,
  name: p,
  description: G,
  image: y,
  validity_period: E,
  amount: u,
  currency: R,
  searchInputs: U,
  onBack: B,
  onClose: M
}) => {
  const [a, c] = F({
    [f]: "",
    [g]: "",
    [_]: "",
    phone: ""
  }), C = m(J), h = m(K), v = m(
    Q
  ), b = m(W), N = m(X), k = m(Y), A = () => {
    const t = a.email;
    return t === "" || L(t) ? r.DEFAULT : r.ERROR;
  }, [q, T] = F(
    A()
  ), [d, O] = F(!1), i = x(
    () => ({
      radio: s("send_gift_card", "gift-card"),
      firstName: s(f, "gift-card"),
      lastName: s(g, "gift-card"),
      email: s(_, "gift-card"),
      phone: s(D, "gift-card")
    }),
    []
  );
  S(() => {
    k(), N(), h({ id: l, name: p, validity_period: E, amount: u });
  }, [
    h,
    l,
    p,
    E,
    u,
    N,
    k
  ]), S(() => {
    let t;
    d ? t = Object.values(a).every((n) => n !== "") && L(a.email) : t = !0, t && v({ id: l, recipientDetails: a }), C({
      disabled: !t
    });
  }, [
    a,
    d,
    C,
    v,
    l
  ]);
  const P = () => {
    b(l), M();
  }, w = () => {
    b(l), B();
  };
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    H,
    {
      title: p,
      onClose: P,
      onBack: w,
      searchInputs: U
    }
  ), /* @__PURE__ */ e.createElement("div", { className: o.container, "data-testid": "selected-gift-card" }, /* @__PURE__ */ e.createElement("div", { className: o.content }, /* @__PURE__ */ e.createElement("div", { className: o["image-container"] }, /* @__PURE__ */ e.createElement("img", { src: y })), /* @__PURE__ */ e.createElement("div", { className: o.price }, z(parseFloat(u), R)), /* @__PURE__ */ e.createElement("div", { className: o.validity_period }, I18n.t("booking_engine.gift_cards.validity_period", {
    count: E.toString()
  })), /* @__PURE__ */ e.createElement("div", { className: o.description }, G)), /* @__PURE__ */ e.createElement(
    "div",
    {
      className: o.send_details_container,
      id: "send-details-step",
      "data-testid": "send-details-step"
    },
    /* @__PURE__ */ e.createElement("div", { className: o.send_gift_card_title }, I18n.t("booking_engine.information.send_gift_card")),
    /* @__PURE__ */ e.createElement(
      V,
      {
        id: i.radio,
        name: "send_gift_card",
        key: "send_gift_card",
        position: "vertical",
        onChange: (t) => {
          O(t);
        },
        value: d,
        state: r.DEFAULT,
        options: [
          {
            label: I18n.t("booking_engine.room.answer_yes"),
            option: !0
          },
          {
            label: I18n.t("booking_engine.room.answer_no"),
            option: !1
          }
        ]
      }
    ),
    d ? /* @__PURE__ */ e.createElement("div", { className: o.gift_to_someone_form }, /* @__PURE__ */ e.createElement(
      I,
      {
        required: !0,
        autocomplete: "given-name",
        id: i.firstName,
        name: f,
        key: i.firstName,
        label: I18n.t("booking_engine.information.name"),
        placeholder: I18n.t(
          "booking_engine.information.name_placeholder"
        ),
        onChange: (t) => {
          c((n) => ({
            ...n,
            [f]: t
          }));
        },
        value: a.first_name,
        state: r.DEFAULT
      }
    ), /* @__PURE__ */ e.createElement(
      I,
      {
        autocomplete: "family-name",
        id: i.lastName,
        key: i.lastName,
        name: g,
        label: I18n.t("booking_engine.information.last_name"),
        placeholder: I18n.t(
          "booking_engine.information.last_name_placeholder"
        ),
        onChange: (t) => {
          c((n) => ({
            ...n,
            [g]: t
          }));
        },
        value: a.last_name,
        required: !0,
        state: r.DEFAULT
      }
    ), /* @__PURE__ */ e.createElement(
      j,
      {
        autocomplete: "email",
        id: i.email,
        name: _,
        required: !0,
        label: I18n.t("booking_engine.information.email"),
        placeholder: I18n.t(
          "booking_engine.information.email_placeholder"
        ),
        value: a.email,
        onChange: (t) => {
          c((n) => ({
            ...n,
            [_]: t
          }));
        },
        onFocus: () => T(r.DEFAULT),
        onBlur: () => T(A()),
        state: q
      }
    ), /* @__PURE__ */ e.createElement(
      I,
      {
        autocomplete: "tel",
        id: i.phone,
        key: i.phone,
        name: D,
        label: I18n.t("booking_engine.information.phone"),
        placeholder: "000000000",
        onChange: (t) => {
          c((n) => ({
            ...n,
            phone: t.replace(/[^0-9+()]/g, "")
          }));
        },
        value: a.phone,
        required: !0,
        state: r.DEFAULT
      }
    )) : null
  )));
};
export {
  se as GiftCardPage
};
